<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Edit Announcement</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        
      </div>
      <div class="col-4">
        <CurrentExtensions default_type="announcement"></CurrentExtensions>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import SoundDropDownAndPreview from '../../components/SoundDropDownAndPreview'
import CurrentExtensions from '../../components/CurrentExtensions'
import ValidationMixin from '../../mixins/ValidationMixin.vue'
import { AlertExtensionValidator } from '../../assets/js/validators'

export default {
  props: [
    'notification_id'
  ],
  components: { vSelect, SoundDropDownAndPreview, CurrentExtensions },
  mixins: [ValidationMixin],
  computed: {
    ...mapGetters({
      notification: 'singleNotification',
      sound_types: 'allSoundTypes',
      playlists: 'allPlaylists',
      zones_for_drop_down: 'allZonesForDropdown', // TODO Account for Zone Tags COMM-188
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_playlists: function () {
      return this.playlists.filter(playlist => playlist.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getNotification', this.notification_id)
    this.$store.dispatch('getZones')
    this.$store.dispatch('getSoundTypes')
    this.$store.dispatch('getPlaylists')
  },
  updated() {
    if(!this.initial_notification_extension && this.notification) this.initial_notification_extension = this.notification.extension
  },
  methods: {
    validate(value) {
      const validator = new AlertExtensionValidator(this.extensions_in_use, this.initial_notification_extension)
      return validator.validate(value)
    },
    submit () {
      this.$store.dispatch('addEditNotification', this.notification)
    }
  }
}
</script>

<style scoped>

</style>
